import React, { useState, useEffect, useRef } from 'react'
import { Alert } from 'antd'
import { IconClock, IconHourGlass, IconTime, IconTimer } from '@edulastic/icons'
import {
  fetchIncompleteConversionsCount,
  INCOMPLETE_CONVERSIONS_POLL_INITIAL_MS,
  INCOMPLETE_CONVERSIONS_POLL_MAX_MS,
} from '../../utils/bulkConverterStatus'
import { BulkConvertStatusBarWrapper } from '../Container/styled'

/**
 * Shows "Creating test questions from your documents" bar on my content page
 * when user lands from bulk convert or while conversions are queued/processing.
 * Polls window.pear.bulkConverter.listConversions with exponential backoff.
 */
const BulkConvertStatusBar = ({ showInitially = false, onComplete }) => {
  const [incompleteCount, setIncompleteCount] = useState(null)
  const intervalRef = useRef(null)
  const delayRef = useRef(INCOMPLETE_CONVERSIONS_POLL_INITIAL_MS)

  const poll = async () => {
    const { count } = await fetchIncompleteConversionsCount()
    setIncompleteCount(count)
    if (count === 0) {
      onComplete?.()
      return
    }
    delayRef.current = Math.min(
      delayRef.current * 2,
      INCOMPLETE_CONVERSIONS_POLL_MAX_MS
    )
    intervalRef.current = setTimeout(poll, delayRef.current)
  }

  useEffect(() => {
    delayRef.current = INCOMPLETE_CONVERSIONS_POLL_INITIAL_MS
    poll()
    return () => {
      if (intervalRef.current) clearTimeout(intervalRef.current)
    }
  }, [showInitially])

  const showBar =
    (showInitially && incompleteCount === null) ||
    (incompleteCount !== null && incompleteCount > 0)
  if (!showBar) return null

  const messageNode = (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 16,
      }}
    >
      <IconHourGlass width={24} height={24} />
      Creating test questions from your documents. This may take a few minutes.
    </div>
  )

  return (
    <BulkConvertStatusBarWrapper role="status" aria-live="polite">
      <Alert type="info" message={messageNode} />
    </BulkConvertStatusBarWrapper>
  )
}

export default BulkConvertStatusBar
